import { render, staticRenderFns } from "./profile-view.page.vue?vue&type=template&id=6087798c&scoped=true&"
import script from "./profile-view.page.vue?vue&type=script&lang=js&"
export * from "./profile-view.page.vue?vue&type=script&lang=js&"
import style0 from "./profile-view.page.vue?vue&type=style&index=0&id=6087798c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6087798c",
  null
  
)

export default component.exports